/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mobilephone'
export default icon
